import React, { useContext, useEffect, useState } from 'react';
import OrgRegister from '../pages/orgRegister/OrgRegister';
import OrgLoginPage from '../pages/orgLoginPage/OrgLoginPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import { OrgAuthContext } from '../context/OrgAuthContext';
import { toast } from 'react-toastify';
import Footer from '../webPageSections/footer/Footer';
import OrgCampLeftMenu from '../components/Camp/orgCampLeftMenu/OrgCampLeftMenu';
import CampDashboard from '../components/Camp/campDashboard/CampDashboard';
import OrgCampPackList from '../components/Camp/orgCampPackList/OrgCampPackList';
import OrgCampBillings from '../components/Camp/orgCampBillings/OrgCampBillings';
import OrgCampBookings from '../components/Camp/orgCampBookings/OrgCampBookings';
import OrgCampReviews from '../components/Camp/orgCampReviews/OrgCampReviews';
import OrgCampInsights from '../components/Camp/orgCampInsights/OrgCampInsights';
import OrgCampAnalytics from '../components/Camp/orgCampAnalytics/OrgCampAnalytics';
import OrgHeader from '../webPageSections/orgPageSection/orgHeader/OrgHeader';
import CampDetailsUpload from '../pages/orgCampUploadAcc/OrgCampUploadAcc';
import OrgAccommodationUpload from '../pages/orgAccommodationUpload/OrgAccommodationUpload';
import OrgCampDetails from '../pages/orgCampDetails/OrgCampDetails';
import OrgCampAddBooking from '../components/Camp/orgStay/OrgCampAddBooking';

const orgClearItems = ['orgName', 'orgId', 'orgToken', 'orgExpiry', 'type', 'org'];
const OrgCampLayout = () => {
    const { isOrgAuthenticated } = useContext(OrgAuthContext);
    // header "Add Booking" popup
    const [addBo, setAddBo] = useState(false);

    const isLoginExpiredOrg = () => {
        const expiryTime = Number(window.localStorage.getItem('orgExpiry'));
        return expiryTime && Date.now() > expiryTime;
    };

    const monitorLoginExpiryOrg = () => {
        const interval = setInterval(() => {
            if (window.location.pathname !== '/org/login') {
                if (isLoginExpiredOrg()) {
                    toast.error('Session has expired. Login again to continue');
                    setTimeout(() => {
                        orgClearItems.forEach((key) => {
                            localStorage.removeItem(key); // Removes the specified key
                        }); // Clear all local storage
                        clearInterval(interval); // Stop further checks
                        window.location = '/org/login';
                    }, 3000);
                }
            }
        }, 10000); // Check every 10 seconds
    };

    useEffect(() => {
        //The below if consition shouln't be used as it will make the duntion
        //not get triggred in other pages also
        monitorLoginExpiryOrg();
        //eslint-disable-next-line
    }, []);
    return (
        <>
            {isOrgAuthenticated ? (
                <>
                    <OrgHeader
                        roleText={['Add Booking', 'Create Camp']}
                        rolelink={['/org/c/create/camp', '/org/c/create/camp']}
                        setAddBo={setAddBo}
                    />
                    <div className='org-main-container'>
                        <OrgCampLeftMenu />
                        <main className='org-content'>
                            <Routes>
                                <Route path='/register' element={<OrgRegister />} />
                                <Route path='/*' element={<Navigate to='dashboard' />} />
                                <Route path='/dashboard' element={<CampDashboard />} />
                                <Route path='/my-camps' element={<OrgCampPackList />} />
                                {/* old link — keep it working */}
                                <Route path='/my-activity' element={<Navigate to='/org/c/my-camps?status=active&page=1' replace />} />
                                <Route path='/billing' element={<OrgCampBillings />} />
                                <Route path='/create/camp' element={<OrgAccommodationUpload />} />
                                <Route path='/payouts' element={<OrgCampBillings />} />
                                <Route path='/upload' element={<CampDetailsUpload />} />
                                <Route path='/bookings' element={<OrgCampBookings />} />
                                <Route path='/reviews' element={<OrgCampReviews />} />
                                <Route path='/insights' element={<OrgCampInsights />} />
                                <Route path='/analytics' element={<OrgCampAnalytics />} />
                                <Route path='/details/:tripId' element={<OrgCampDetails />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                    {addBo && <OrgCampAddBooking setAddBo={setAddBo} />}
                </>
            ) : (
                <Routes>
                    <Route path='/login' element={<OrgLoginPage />} />
                    <Route path='/*' element={<Navigate to='login' />} />
                    <Route path='/register' element={<OrgRegister />} />
                </Routes>
            )}
        </>
    );
};

export default OrgCampLayout;
